import React from "react";

const MinusIcon = () => (
  <svg width={14} height={2} viewBox="0 0 14 2" fill="none">
    <path
      d="M1 1H13"
      stroke="#242424"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default MinusIcon;
